/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GetMonatsauswertungForMitarbeiterCsv$Params {

/**
 * ID des Mitarbeiters
 */
  mitarbeiterId: string;

/**
 * Monat für den die Auswertung erstellt werden soll
 */
  monat: string;

/**
 * ID des Layouts, dass verwendet werden soll
 */
  layoutId?: string;
}

export function getMonatsauswertungForMitarbeiterCsv(http: HttpClient, rootUrl: string, params: GetMonatsauswertungForMitarbeiterCsv$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, getMonatsauswertungForMitarbeiterCsv.PATH, 'get');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.path('monat', params.monat, {});
    rb.query('layoutId', params.layoutId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

getMonatsauswertungForMitarbeiterCsv.PATH = '/v1/mitarbeiter/{mitarbeiterId}/monatsauswertung/{monat}/csv';
